export default "/images/vendor/flag-icon-css/flags/4x3/tv.svg?12b93537c4398ab123fb2669edbd14b2";